module.exports = __webpack_public_path__ + "media/images/svgs/multi-persons-icon-a01245e84be0cabceb13a32af08bf907.svg";